import { Injectable } from '@angular/core';
import { ListBasketInsightSort } from '@epicuro-next/data/reporting-api';
import {
  loadListAnalytics,
  loadListsReports,
} from '@epicuro-next/state/analytics-entities';
import { loadNextListProducts } from '@epicuro-next/state/list-entities';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap } from 'rxjs/operators';

import { setLookbookListIdInRouter } from './shop-the-look-core.actions';

@Injectable()
export class ShopTheLookCoreEffects {
  constructor(private actions$: Actions) {}

  public loadListProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setLookbookListIdInRouter),
      map((action) => action.lookbookListId),
      filter(isNonNullish),
      map((listId) => loadNextListProducts({ listId })),
    ),
  );

  public loadLookbookListAnalytics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setLookbookListIdInRouter),
      filter(({ lookbookListId }) => isNonNullish(lookbookListId)),
      switchMap(({ lookbookListId }) => [
        loadListsReports({
          listIds: [lookbookListId as string],
        }),
        loadListAnalytics({
          listId: lookbookListId as string,
          sortBy: ListBasketInsightSort.MostRevenue,
        }),
      ]),
    ),
  );
}
